import { Component, OnInit, Input, ElementRef, ViewChild, AfterViewInit, HostBinding, SimpleChange } from '@angular/core';
import { FUploadFileExtend } from '../../model';

@Component({
  selector: 'ffile-multi-download-info',
  templateUrl: './multi-download-info.component.html',
  styleUrls: ['./multi-download-info.component.css']
})
export class MultiDownloadInfoComponent implements OnInit,AfterViewInit {
  @HostBinding('class.ffile-multi-download-info') cls=true;
  @ViewChild('multiRenameInput') multiRenameRef: ElementRef;
  // 记载下载数据
  private _downloadInfos: FUploadFileExtend[] = [];
  @Input()
  set downloadInfos(value) {
    if (value && value.length > 0) {
      this._downloadInfos = value;
      if (!this._downloadName) {
        this.downloadName = this.getName(this._downloadInfos[0]['name']);
      }
    }
  }
  get downloadInfos() {
    return this._downloadInfos;
  }
  // 默认名称
  private _downloadName = '';
  @Input()
  set downloadName(value: string) {
    this._downloadName=value;    
  }
  get downloadName() {
    if(!this._downloadName&&this._downloadInfos.length>0){
      this._downloadName = this.getName(this._downloadInfos[0]['name']);
    }    
    return this._downloadName;
  }

  fileTypeCls = '';

  constructor() { }

  ngOnInit() {
   
  }
  ngAfterViewInit(){
    //this.multiRenameRef.nativeElement.value = this.downloadName;
  }
  /**
   * 获取下载名称
   */
  getDownloadName() {
    return  this.multiRenameRef.nativeElement.value;
  }
  private getName(name: string) {
    if (name.lastIndexOf('.') > 0) {
      return name.substring(0, name.lastIndexOf('.'));
    }
    return '';
  }

  getFileTypeClassName(filename: string) {

  }
}
